<div class="quran-page">

  <!-- Hero Banner -->
  <div class="quran-hero-wrap">
    <section class="quran-hero">
      <div class="quran-hero__bg"></div>
      <div class="quran-hero__overlay"></div>
      <div class="quran-hero__content">
        <div class="quran-hero__arabic">القُرْآنُ الكَرِيمُ</div>
        <h1 class="quran-hero__title">Al-Quran</h1>
        <p class="quran-hero__subtitle">✦ Read, Reflect &amp; Connect with Allah ✦</p>
        <div class="quran-hero__divider" aria-hidden="true">❖</div>
      </div>
    </section>
  </div>

  <!-- Page body -->
  <div class="quran-page__body">

    <!-- Top row: Continue Reading + Today's Goal + Quick Actions -->
    <div class="quran-top-row">

      <!-- Continue Reading -->
      <div class="quran-card quran-continue">
        <div class="quran-continue__header">
          <span class="quran-continue__icon">📖</span>
          <div>
            <div class="quran-continue__title">Continue Reading</div>
            <div class="quran-continue__meta">Juz {{ continueReading.juz }} &bull; Page {{ continueReading.page }}</div>
          </div>
        </div>
        <div class="quran-continue__ayah">{{ continueReading.arabic }}</div>
        <div class="quran-continue__surah">{{ continueReading.surah }}</div>
        <div class="quran-continue__progress-wrap">
          <div class="quran-continue__progress-bar" [style.width.%]="continueReading.percent"></div>
        </div>
        <div class="quran-continue__percent">{{ continueReading.percent }}% Completed</div>
      </div>

      <!-- Today's Goal -->
      <div class="quran-card quran-goal">
        <div class="quran-goal__label">Today's Goal</div>
        <div class="quran-goal__count">
          <span class="quran-goal__read">{{ todaysGoal.read }}</span>
          <span class="quran-goal__sep"> / </span>
          <span class="quran-goal__total">{{ todaysGoal.total }}</span>
        </div>
        <div class="quran-goal__sub">Pages Read</div>
        <div class="quran-goal__img" aria-hidden="true">📗</div>
        <button type="button" class="quran-goal__btn">Update Goal</button>
      </div>

      <!-- Quick Actions -->
      <div class="quran-card quran-actions">
        <div class="quran-actions__row">
          @for (a of quickActions; track a.label) {
            <button type="button" class="quran-action-btn">
              <span class="quran-action-btn__icon">{{ a.icon }}</span>
              <span class="quran-action-btn__label">{{ a.label }}</span>
            </button>
          }
        </div>
        <div class="quran-actions__divider"></div>
        <div class="quran-actions__row quran-actions__row--tools">
          @for (t of quickTools; track t.label) {
            <button type="button" class="quran-action-btn">
              <span class="quran-action-btn__icon">{{ t.icon }}</span>
              <span class="quran-action-btn__label">{{ t.label }}</span>
              @if (t.sub) {
                <span class="quran-action-btn__sub">{{ t.sub }}</span>
              }
            </button>
          }
        </div>
      </div>

    </div>

    <!-- Main row: Surahs + Sidebar -->
    <div class="quran-main-row">

      <!-- Surahs section -->
      <div class="quran-surahs">
        <div class="quran-surahs__header">
          <span class="quran-surahs__icon">📋</span>
          <span class="quran-surahs__title">Surahs</span>
          <a class="quran-surahs__view-all" routerLink="/quran/surahs">View All →</a>
        </div>

        <!-- Filter tabs -->
        <div class="quran-filter-tabs">
          @for (tab of filterTabs; track tab.key) {
            <button type="button"
                    class="quran-filter-tab"
                    [class.quran-filter-tab--active]="activeFilter() === tab.key"
                    (click)="setFilter(tab.key)">
              {{ tab.label }}
            </button>
          }
        </div>

        <!-- Surah list (2 columns) -->
        <div class="quran-surah-grid">
          @for (pair of surahPairs; track pair[0].number) {
            <div class="quran-surah-item">
              <div class="quran-surah-item__num">{{ pair[0].number }}</div>
              <div class="quran-surah-item__info">
                <div class="quran-surah-item__arabic">{{ pair[0].arabic }}</div>
                <div class="quran-surah-item__name">{{ pair[0].name }} · {{ pair[0].translation }}</div>
              </div>
              <div class="quran-surah-item__ayahs">{{ pair[0].ayahs }}<br><span>Ayahs</span></div>
              <div class="quran-surah-item__arrow">›</div>
            </div>
            @if (pair[1]) {
              <div class="quran-surah-item">
                <div class="quran-surah-item__num">{{ pair[1].number }}</div>
                <div class="quran-surah-item__info">
                  <div class="quran-surah-item__arabic">{{ pair[1].arabic }}</div>
                  <div class="quran-surah-item__name">{{ pair[1].name }} · {{ pair[1].translation }}</div>
                </div>
                <div class="quran-surah-item__ayahs">{{ pair[1].ayahs }}<br><span>Ayahs</span></div>
                <div class="quran-surah-item__arrow">›</div>
              </div>
            }
          }
        </div>

        <!-- Features strip -->
        <div class="quran-features">
          @for (f of features; track f.title) {
            <div class="quran-feature">
              <span class="quran-feature__icon">{{ f.icon }}</span>
              <div>
                <div class="quran-feature__title">{{ f.title }}</div>
                <div class="quran-feature__desc">{{ f.desc }}</div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Right Sidebar -->
      <div class="quran-sidebar">

        <!-- Daily Verse -->
        <div class="quran-sidebar-card quran-daily-verse">
          <div class="quran-sidebar-card__header">
            <span>📖 Daily Verse</span>
            <button type="button" class="quran-share-btn">⤴</button>
          </div>
          <div class="quran-daily-verse__arabic">{{ dailyVerse.arabic }}</div>
          <div class="quran-daily-verse__english">{{ dailyVerse.english }}</div>
          <div class="quran-daily-verse__ref">{{ dailyVerse.reference }}</div>
          <div class="quran-daily-verse__deco" aria-hidden="true">🌿</div>
        </div>

        <!-- Quran Statistics -->
        <div class="quran-sidebar-card">
          <div class="quran-sidebar-card__header">
            <span>📊 Quran Statistics</span>
            <a class="quran-sidebar-card__view-all">View All</a>
          </div>
          <div class="quran-sidebar-card__sub">Your Progress</div>
          <div class="quran-stats-grid">
            <div class="quran-stat">
              <div class="quran-stat__icon">📖</div>
              <div class="quran-stat__val">{{ stats.juzRead }} / {{ stats.juzTotal }}</div>
              <div class="quran-stat__label">Juz Read</div>
            </div>
            <div class="quran-stat">
              <div class="quran-stat__icon">📄</div>
              <div class="quran-stat__val">{{ stats.pagesRead }} / {{ stats.pagesTotal }}</div>
              <div class="quran-stat__label">Pages Read</div>
            </div>
            <div class="quran-stat">
              <div class="quran-stat__icon">✨</div>
              <div class="quran-stat__val">{{ stats.versesRead }} / {{ stats.versesTotal }}</div>
              <div class="quran-stat__label">Verses Read</div>
            </div>
            <div class="quran-stat">
              <div class="quran-stat__icon">🕐</div>
              <div class="quran-stat__val">{{ stats.timeSpent }}</div>
              <div class="quran-stat__label">Time Spent</div>
            </div>
          </div>
        </div>

        <!-- Juz' Quick Access -->
        <div class="quran-sidebar-card">
          <div class="quran-sidebar-card__header">
            <span>📚 Juz' Quick Access</span>
            <a class="quran-sidebar-card__view-all">View All</a>
          </div>
          <div class="quran-juz-list">
            @for (juz of juzList; track juz.number) {
              <button type="button" class="quran-juz-btn" [class.quran-juz-btn--active]="juz.number === 2">
                <div class="quran-juz-btn__num">Juz {{ juz.number }}</div>
                <div class="quran-juz-btn__pages">{{ juz.pages }}</div>
              </button>
            }
            <button type="button" class="quran-juz-btn quran-juz-btn--more">›</button>
          </div>
        </div>

        <!-- Tip of the Day -->
        <div class="quran-sidebar-card quran-tip">
          <div class="quran-tip__icon">💡</div>
          <div>
            <div class="quran-tip__label">Tip of the Day</div>
            <div class="quran-tip__text">{{ tipOfDay }}</div>
          </div>
          <div class="quran-tip__deco" aria-hidden="true">🌙</div>
        </div>

      </div>
    </div>
  </div>
</div>
